<template>
  <div class="pagination">
    <div class="page-prev" v-if="btnPrev" @click="prev">
      <img src="@/assets/img/arrow-back.png">
    </div>

    <div class="page-text">
      {{num + 1}} / {{pages}}
    </div>
    
    <div class="page-next" v-if="btnNext" @click="next">
      <img src="@/assets/img/arrow-next.png">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    num: Number,
    pages: Number
  },
  computed: {
    btnNext() {
      return this.num < this.pages - 1;
    },
    btnPrev() {
      return this.num > 0;
    }
  },
  methods: {
    next() {
      this.$emit("change", this.num + 1);
    },
    prev() {
      this.$emit("change", this.num - 1);
    }
  }
};
</script>

<style lang="scss">
@import "../assets/base";
.pagination {
  position: relative;
  height: 1.5rem;
  text-align: center;
  @include img-fluid-height;

  & > div {
    display: inline-block;
  }

  .page-prev,
  .page-next {
    width: 1.5rem;
    height: 100%;
    margin: 0 1rem;
    vertical-align: top;
  }

  .page-text {
    height: 1.5rem;
    line-height: 1.5rem;
  }
}
</style>
